import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { ArticleFragmentDoc } from './Article.fragment';
export type LatestArticlesFragment = {
	__typename?: 'HMLatestArticles';
	category: string;
	moduleID: number;
	type: string;
	translatables: { __typename?: 'ModuleTranslatables'; badge: string; title: string };
	articles: Array<{
		__typename: 'Article';
		id: string;
		author: {
			__typename?: 'Author';
			id: string;
			content: {
				__typename?: 'AuthorContent';
				clearName: string;
				imageUrl?: string | null;
				fullPath: string;
				bio?: string;
				alumniOf?: Array<string>;
				brand?: string;
				languagesSpoken?: Array<any>;
				occupation?: Array<string>;
				publications?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
				socialHandles?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
			};
		};
		content: {
			__typename?: 'ArticleContent';
			id: number;
			fullPath: string;
			title?: string | null;
			articleType: Types.ArticleType;
			updatedAt: any;
			createdAt: any;
			subtitle?: string | null;
			paragraph1?: string | null;
			paragraph2?: string | null;
			synopsis?: string | null;
			whereToWatch?: string | null;
			whatToKnow?: string | null;
			productionNews?: string | null;
			titleOrderMode?: string;
			isLegacy?: boolean;
			headerImage?: { __typename?: 'ArticleImage'; url: string; altText: string } | null;
			mainImageEntityBackdrop?: { __typename?: 'Backdrop'; backdropUrl: string } | null;
			images?: Array<{
				__typename?: 'ArticleImage';
				url: string;
				altText: string;
				blurHash: string;
				imageType: string;
				language?: string | null;
			}> | null;
		};
		mainObjects: Array<{
			__typename: 'ArticleLinkedObject';
			node:
				| { __typename: 'Article' }
				| { __typename: 'Author' }
				| { __typename: 'Bundle' }
				| { __typename: 'Device' }
				| { __typename: 'Episode' }
				| {
						__typename: 'GenericTitleList';
						id: string;
						content: { __typename?: 'GenericTitleListContent'; name: string };
						followedlistEntry?: { __typename?: 'FollowedListEntry'; createdAt: any } | null;
						titles: {
							__typename?: 'GenericTitleListConnection';
							totalCount: number;
							pageInfo: {
								__typename?: 'PageInfo';
								endCursor: string;
								hasNextPage: boolean;
								hasPreviousPage: boolean;
								startCursor: string;
							};
							edges?: Array<{
								__typename?: 'GenericTitleListEdge';
								data: {
									__typename?: 'TitleListEntryData';
									overrides?: Array<{
										__typename?: 'TitleListEntryDataOverride';
										languageOrLocale: string;
										shortDescription?: string | null;
										title?: string | null;
									}> | null;
								};
								node:
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												fullPath: string;
												originalReleaseYear?: number | null;
												shortDescription?: string | null;
												posterUrl?: string | null;
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													imdbVotes?: number | null;
													tmdbPopularity?: number | null;
													tmdbScore?: number | null;
												};
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											offers?: Array<{
												__typename?: 'Offer';
												id: string;
												currency?: string | null;
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												retailPrice?: string | null;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												package: { __typename?: 'Package'; shortName: string; id: string };
											}>;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											seenState: {
												__typename?: 'ShowSeenState';
												progress: number;
												seenEpisodeCount: number;
											};
											content: {
												__typename?: 'ShowContent';
												title: string;
												fullPath: string;
												originalReleaseYear?: number | null;
												shortDescription?: string | null;
												posterUrl?: string | null;
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													imdbVotes?: number | null;
													tmdbPopularity?: number | null;
													tmdbScore?: number | null;
												};
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											offers?: Array<{
												__typename?: 'Offer';
												id: string;
												currency?: string | null;
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												retailPrice?: string | null;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												package: { __typename?: 'Package'; shortName: string; id: string };
											}>;
									  };
							}> | null;
						};
				  }
				| { __typename: 'Genre' }
				| { __typename: 'HomePage' }
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							posterUrl?: string | null;
							isReleased: boolean;
							credits: Array<{
								__typename?: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
							}>;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						fallBackClips: {
							__typename?: 'MovieContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| { __typename: 'MultiStepSportEvent' }
				| { __typename: 'Offer' }
				| { __typename: 'OfferHistory' }
				| { __typename: 'Package' }
				| { __typename: 'Page' }
				| { __typename: 'Person' }
				| { __typename: 'PressRelease' }
				| { __typename: 'ProfileV2' }
				| {
						__typename: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'SeasonContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							posterUrl?: string | null;
							isReleased: boolean;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						fallBackClips: {
							__typename?: 'SeasonContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							posterUrl?: string | null;
							isReleased: boolean;
							credits: Array<{
								__typename?: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
							}>;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						fallBackClips: {
							__typename?: 'ShowContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| { __typename: 'SingleStepSportEvent' }
				| { __typename: 'SportCompetitionV2' }
				| { __typename: 'SportCompetitorV2' }
				| { __typename: 'SportMatch' }
				| { __typename: 'Url' }
				| { __typename: 'UserProviderSubscription' };
		}>;
		secondaryObjects: Array<{
			__typename?: 'ArticleLinkedObject';
			node:
				| { __typename?: 'Article' }
				| { __typename?: 'Author' }
				| { __typename?: 'Bundle' }
				| { __typename?: 'Device' }
				| { __typename?: 'Episode' }
				| {
						__typename: 'GenericTitleList';
						id: string;
						content: { __typename?: 'GenericTitleListContent'; name: string };
						followedlistEntry?: { __typename?: 'FollowedListEntry'; createdAt: any } | null;
						titles: {
							__typename?: 'GenericTitleListConnection';
							totalCount: number;
							pageInfo: {
								__typename?: 'PageInfo';
								endCursor: string;
								hasNextPage: boolean;
								hasPreviousPage: boolean;
								startCursor: string;
							};
							edges?: Array<{
								__typename?: 'GenericTitleListEdge';
								data: {
									__typename?: 'TitleListEntryData';
									overrides?: Array<{
										__typename?: 'TitleListEntryDataOverride';
										languageOrLocale: string;
										shortDescription?: string | null;
										title?: string | null;
									}> | null;
								};
								node:
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												fullPath: string;
												originalReleaseYear?: number | null;
												shortDescription?: string | null;
												posterUrl?: string | null;
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													imdbVotes?: number | null;
													tmdbPopularity?: number | null;
													tmdbScore?: number | null;
												};
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											offers?: Array<{
												__typename?: 'Offer';
												id: string;
												currency?: string | null;
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												retailPrice?: string | null;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												package: { __typename?: 'Package'; shortName: string; id: string };
											}>;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											seenState: {
												__typename?: 'ShowSeenState';
												progress: number;
												seenEpisodeCount: number;
											};
											content: {
												__typename?: 'ShowContent';
												title: string;
												fullPath: string;
												originalReleaseYear?: number | null;
												shortDescription?: string | null;
												posterUrl?: string | null;
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													imdbVotes?: number | null;
													tmdbPopularity?: number | null;
													tmdbScore?: number | null;
												};
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											offers?: Array<{
												__typename?: 'Offer';
												id: string;
												currency?: string | null;
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												retailPrice?: string | null;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												package: { __typename?: 'Package'; shortName: string; id: string };
											}>;
									  };
							}> | null;
						};
				  }
				| { __typename?: 'Genre' }
				| { __typename?: 'HomePage' }
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							posterUrl?: string | null;
							isReleased: boolean;
							credits: Array<{
								__typename?: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
							}>;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						fallBackClips: {
							__typename?: 'MovieContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| { __typename?: 'MultiStepSportEvent' }
				| { __typename?: 'Offer' }
				| { __typename?: 'OfferHistory' }
				| { __typename?: 'Package' }
				| { __typename?: 'Page' }
				| { __typename?: 'Person' }
				| { __typename?: 'PressRelease' }
				| { __typename?: 'ProfileV2' }
				| {
						__typename: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'SeasonContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							posterUrl?: string | null;
							isReleased: boolean;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						fallBackClips: {
							__typename?: 'SeasonContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							posterUrl?: string | null;
							isReleased: boolean;
							credits: Array<{
								__typename?: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
							}>;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						fallBackClips: {
							__typename?: 'ShowContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| { __typename?: 'SingleStepSportEvent' }
				| { __typename?: 'SportCompetitionV2' }
				| { __typename?: 'SportCompetitorV2' }
				| { __typename?: 'SportMatch' }
				| { __typename?: 'Url' }
				| { __typename?: 'UserProviderSubscription' };
		}>;
		supportingObjects: Array<{
			__typename?: 'ArticleLinkedObject';
			node:
				| { __typename?: 'Article' }
				| { __typename?: 'Author' }
				| { __typename?: 'Bundle' }
				| { __typename?: 'Device' }
				| { __typename?: 'Episode' }
				| {
						__typename: 'GenericTitleList';
						id: string;
						content: { __typename?: 'GenericTitleListContent'; name: string };
						followedlistEntry?: { __typename?: 'FollowedListEntry'; createdAt: any } | null;
						titles: {
							__typename?: 'GenericTitleListConnection';
							totalCount: number;
							pageInfo: {
								__typename?: 'PageInfo';
								endCursor: string;
								hasNextPage: boolean;
								hasPreviousPage: boolean;
								startCursor: string;
							};
							edges?: Array<{
								__typename?: 'GenericTitleListEdge';
								data: {
									__typename?: 'TitleListEntryData';
									overrides?: Array<{
										__typename?: 'TitleListEntryDataOverride';
										languageOrLocale: string;
										shortDescription?: string | null;
										title?: string | null;
									}> | null;
								};
								node:
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												fullPath: string;
												originalReleaseYear?: number | null;
												shortDescription?: string | null;
												posterUrl?: string | null;
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													imdbVotes?: number | null;
													tmdbPopularity?: number | null;
													tmdbScore?: number | null;
												};
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											offers?: Array<{
												__typename?: 'Offer';
												id: string;
												currency?: string | null;
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												retailPrice?: string | null;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												package: { __typename?: 'Package'; shortName: string; id: string };
											}>;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											seenState: {
												__typename?: 'ShowSeenState';
												progress: number;
												seenEpisodeCount: number;
											};
											content: {
												__typename?: 'ShowContent';
												title: string;
												fullPath: string;
												originalReleaseYear?: number | null;
												shortDescription?: string | null;
												posterUrl?: string | null;
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													imdbVotes?: number | null;
													tmdbPopularity?: number | null;
													tmdbScore?: number | null;
												};
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											offers?: Array<{
												__typename?: 'Offer';
												id: string;
												currency?: string | null;
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												retailPrice?: string | null;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												package: { __typename?: 'Package'; shortName: string; id: string };
											}>;
									  };
							}> | null;
						};
				  }
				| { __typename?: 'Genre' }
				| { __typename?: 'HomePage' }
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							posterUrl?: string | null;
							isReleased: boolean;
							credits: Array<{
								__typename?: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
							}>;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						fallBackClips: {
							__typename?: 'MovieContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| { __typename?: 'MultiStepSportEvent' }
				| { __typename?: 'Offer' }
				| { __typename?: 'OfferHistory' }
				| { __typename?: 'Package' }
				| { __typename?: 'Page' }
				| { __typename?: 'Person' }
				| { __typename?: 'PressRelease' }
				| { __typename?: 'ProfileV2' }
				| { __typename?: 'Season' }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							posterUrl?: string | null;
							isReleased: boolean;
							credits: Array<{
								__typename?: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
							}>;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbScore?: number | null;
								imdbVotes?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						fallBackClips: {
							__typename?: 'ShowContent';
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
							}>;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| { __typename?: 'SingleStepSportEvent' }
				| { __typename?: 'SportCompetitionV2' }
				| { __typename?: 'SportCompetitorV2' }
				| { __typename?: 'SportMatch' }
				| { __typename?: 'Url' }
				| { __typename?: 'UserProviderSubscription' };
		}>;
	}>;
};

export const LatestArticlesFragmentDoc = gql`
	fragment LatestArticles on HMLatestArticles {
		category
		moduleID
		translatables {
			badge
			title
		}
		type
		articles {
			...Article
		}
	}
	${ArticleFragmentDoc}
`;
